import './button.css'

function Button(props:{name : string, link : string, height : number, width : number, marginTop : number}) {
    return (
          <a href={props.link}><button className='Button' style={{ height: `${props.height}px`, width:`${props.width}px`, marginTop:`${props.marginTop}px` } }>{props.name}</button></a>
    );
  }
  export default Button;